import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "btn-back_container"
}

import FooterComponent from '@/components/core/Footer/FooterComponent.vue';
import HeaderComponent from '@/components/core/HeaderComponent/HeaderComponent.vue';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';


// eslint-disable-next-line no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  props: {
  hasBack: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const childValue = ref<boolean>(true);
const router = useRouter();
const isMobile = ref(window.innerWidth <= 768);

const goBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/'); // Redirigir a la home si no hay historial previo
  }
};

const handleExpandedValue = (value: string): void => {
  childValue.value = value;
};

const checkHeight = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  checkHeight();
  window.addEventListener("resize", checkHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent, { onExpanded: handleExpandedValue }),
    _createElementVNode("main", {
      class: _normalizeClass(['layout-content', { expanded: childValue.value }]),
      style: _normalizeStyle((isMobile.value)?`min-height: calc(var(--vh) - 6.4rem)`:'min-height:var(--vh)')
    }, [
      (__props.hasBack)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "btn-back",
              onClick: goBack
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "bp-icon-Back btn-back-icon" }, null, -1),
              _createElementVNode("span", { class: "btn-back-label" }, "volver", -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, null, -1))
      ])
    ], 6),
    _createElementVNode("footer", {
      class: _normalizeClass({'expanded': childValue.value })
    }, [
      _createVNode(FooterComponent)
    ], 2)
  ], 64))
}
}

})